import axios from 'axios';

export const saveLock = async (matchId, lineItemId, setData, comparisonID) => {
  let updatedData = null;

  setData((prevData) => {
    if (
      !prevData ||
      !prevData.results ||
      !prevData.cleanParsedEstData ||
      !prevData.cleanParsedInsData
    ) {
      console.error("❌ Missing expected data structure");
      return prevData;
    }

    const newData = structuredClone(prevData);
    updatedData = newData;

    const result = newData.results.find((r) => r.id === matchId);
    if (!result) {
      console.error(`❌ No result found for matchId: ${matchId}`);
      return prevData;
    }

    const matchObj = result.Matches[0];
    const matchKey = Object.keys(matchObj)[0];
    const matchBlock = matchObj[matchKey];
    const userModified = matchBlock["User Modified"];

    if (!userModified) {
      console.error(`❌ No User Modified block in match ${matchId}`);
      return prevData;
    }

    const isDoc1 = userModified.doc1?.ids?.includes(lineItemId) || false;
    const isDoc2 = userModified.doc2?.ids?.includes(lineItemId) || false;

    if (!isDoc1 && !isDoc2) {
      console.warn(`⚠️ Line item ${lineItemId} not found in User Modified block of match ${matchId}`);
      return prevData;
    }

    // Toggle locked on matching line item
    const targetLineItems = isDoc1
      ? newData.cleanParsedEstData.lineItems
      : newData.cleanParsedInsData.lineItems;

    let found = false;
    for (const obj of targetLineItems) {
      const key = Object.keys(obj)[0];
      const item = obj[key];
      if (key === lineItemId && item) {
        item.locked = !item.locked;
        found = true;
        break;
      }
    }

    if (!found) {
      console.warn(`⚠️ Could not find lineItemId: ${lineItemId} in ${isDoc1 ? "EstData" : "InsData"}`);
      return prevData;
    }

    // Remove lineItemId from all other Matches
    newData.results.forEach((res) => {
      res.Matches.forEach((match) => {
        const matchKey = Object.keys(match)[0];
        const block = match[matchKey];
        const um = block["User Modified"];
        if (!um) return;

        const isCurrentMatch = res.id === matchId;

        if (!um["Allowed Ids"]) um["Allowed Ids"] = [];

        if (isCurrentMatch) {
          if (!um["Allowed Ids"].includes(lineItemId)) {
            um["Allowed Ids"].push(lineItemId);
          }
        } else {
          const doc1Ids = um.doc1?.ids || [];
          const doc2Ids = um.doc2?.ids || [];

          const isOnlyDoc1 =
            doc1Ids.includes(lineItemId) && doc1Ids.length === 1;

          if (isOnlyDoc1) {
            // Remove all line items from this match
            um.doc1.ids = [];
            um.doc2.ids = [];

            // Remove from Allowed Ids
            um["Allowed Ids"] = um["Allowed Ids"].filter(
              (id) => id !== lineItemId && !doc2Ids.includes(id)
            );
          } else {
            // Otherwise just remove this lineItemId from all applicable locations
            um["Allowed Ids"] = um["Allowed Ids"].filter((id) => id !== lineItemId);

            if (um.doc1?.ids) {
              um.doc1.ids = um.doc1.ids.filter((id) => id !== lineItemId);
            }

            if (um.doc2?.ids) {
              um.doc2.ids = um.doc2.ids.filter((id) => id !== lineItemId);
            }
          }
        }
      });
    });

    return newData;
  });

  // Wait one tick for state to update
  await new Promise((resolve) => setTimeout(resolve, 0));

  if (!updatedData) {
    console.error("❌ No updated data available for DB sync");
    return;
  }

  try {
    const isDoc1 = updatedData.cleanParsedEstData.lineItems.some((obj) =>
      Object.keys(obj)[0] === lineItemId
    );

    const zoneURL = isDoc1
      ? `${process.env.REACT_APP_ZONE1_UPDATE}/${comparisonID}`
      : `${process.env.REACT_APP_ZONE2_UPDATE}/${comparisonID}`;

    const resultsURL = `${process.env.REACT_APP_UPDATE_RESULTS}/${updatedData?.resultsID}`;

    const [zoneRes, resultsRes] = await Promise.all([
      axios.put(zoneURL, {
        [isDoc1 ? "cleanParsedEstData" : "cleanParsedInsData"]: isDoc1
          ? updatedData.cleanParsedEstData
          : updatedData.cleanParsedInsData,
      }),
      axios.put(resultsURL, { data: updatedData }),
    ]);

  } catch (error) {
    console.error("❌ Error updating DB:", error);
  }
};
